<template>
  <div></div>
</template>

<script>
/**
 * マップ上にアンカーを表示するコンポーネント
 * @parent LiveMap
 * @props isReady: Boolean マップ情報が描画されているかのフラグ
 * @props mapEvent: String マップ上操作でのイベント名
 */
import { AnchorPointsMapLayer, MapSource } from "@/config/Map.js";
import Mapbox from "mapbox-gl";

export default {
  name: "O.VesselAnchorPointsLayer",
  props: {
    map: Object,
    isReady: { type: Boolean, default: false },
    mapEvent: String,
  },
  data() {
    return {
      initialized: false,
      isPopup: false,
    };
  },
  watch: {
    isReady() {
      if (this.isReady) {
        this.isMapReady();
        this.setPointerStyle();
      }
      if (!this.initialized) {
        this.initialized = true;
      }
    },
  },
  methods: {
    /** レイヤーの描画処理 */
    isMapReady() {
      if (!this.initialized) {
        this.setPointerStyle();
      }
      // アンカーのポイント
      this.map.addLayer({
        id: AnchorPointsMapLayer.AnchorPointLayer.id,
        type: "symbol",
        source: MapSource.AnchorPointSource.id,
        minzoom: 10,
        layout: {
          "icon-allow-overlap": true,
          "icon-ignore-placement": true,
          "icon-image": "triangle-anchor-fixed",
          "icon-rotate": {
            type: "identity",
            property: "r",
          },
        },
      });

      // アンカーと船舶を結ぶ線
      this.map.addLayer({
        id: AnchorPointsMapLayer.AnchorToVesselLineLayer.id,
        type: "line",
        source: MapSource.AnchorToVesselLineSource.id,
        minzoom: 10,
        layout: {
          "line-join": "round",
          "line-cap": "round",
        },
        paint: {
          "line-color": "#FA678A",
          "line-width": 1.0,
        },
      });
    },
    setCursor(isPointer, self) {
      self.map.getCanvas().style.cursor = isPointer ? "pointer" : "";
    },
    setPointerStyle() {
      let self = this;
      let popup = new Mapbox.Popup({
        closeButton: false,
        offset: 15,
        anchor: "bottom",
        className: "anchor-distance-popup",
      });
      this.map.on(
        "mousemove",
        AnchorPointsMapLayer.AnchorPointLayer.id,
        (e) => {
          self.setCursor(true, self);
          // 二重にポップアップ作られるのを防止する
          if (this.isPopup) return;
          this.isPopup = true;
          popup
            .setLngLat(e.lngLat)
            .setHTML(
              `<div class="aisea-text-12-600-white">${e.features[0].properties.d}m</div>`,
            )
            .addTo(self.map);
        },
      );
      this.map.on(
        "mouseleave",
        AnchorPointsMapLayer.AnchorPointLayer.id,
        (_e) => {
          self.setCursor(false, self);
          this.isPopup = false;
          popup.remove();
        },
      );
    },
  },
};
</script>

<style lang="scss">
.anchor-distance-popup {
  // 背景の変更
  .mapboxgl-popup-content {
    background-color: #2d3240 !important;
    padding: 10px 12px;
  }
  // 吹き出しの色を変える
  .mapboxgl-popup-tip {
    border-top-color: #2d3240 !important;
  }
}
</style>
